<script>
import MealtimeDishesStack from '@components/recipe/mealtime-dishes-stack.vue';
import { homeComputed, orgComputed } from '@state/helpers';

export default {
  components: {
    MealtimeDishesStack,
  },
  computed: {
    ...homeComputed,
    ...orgComputed,
    visibleDishes() {
      const mealtimes = ['Breakfast', 'Lunch', 'Dinner'];
      return mealtimes
        .map((mealtimeName) => {
          const mealtime = this.homeOverview.todaysMeals[mealtimeName];
          return mealtime.meals.concat(mealtime.recipes).concat(mealtime.leftovers);
        })
        .flat()
        .slice(0, 5);
    },
    hasMeals() {
      return (
        this.homeOverview &&
        this.homeOverview.todaysMeals &&
        this.homeOverview.todaysMeals.aggregatedNutritionDigest &&
        this.homeOverview.todaysMeals.aggregatedNutritionDigest.recipesWithNutrition
      );
    },
    cssVars() {
      return {
        '--color': this.primaryColor
      }
    }
  },
  methods: {
    toNutrition() {
      this.$router.push({ name: 'nutrition' });
    },
  },
};
</script>

<template>
  <div :class="['card-daily-meals', { noMeals: !hasMeals }]" @click="toNutrition" :style="cssVars">
    <b-row>
      <b-col md="12" sm="12">
        <div class="daily-meals-header">
          <h2>Today’s Meals</h2>
          <span @click="toNutrition">Start Planning</span>
        </div>
      </b-col>
      <b-col md="12" sm="12">
        <MealtimeDishesStack :dishes="visibleDishes" :lastClickableDishImg="true" v-if="hasMeals" />
        <div class="no-results" v-else
          >It looks like you don't have any recipes in your plan yet. Grab a curated recipe plan to get started quickly. Or you
          can build your own.</div
        >
      </b-col>
    </b-row>
  </div>
</template>

<style lang="scss" scoped>
@import '@design';

.card-daily-meals {
  background: white;
  border-radius: $base-border-radius-lg;
  box-shadow: $color-card-minimal-mobile-box-shadow;
  height: 100%;
  padding: 1.7rem 2rem;

  // XL Tablet up
  @include media('xl', null) {
    box-shadow: $color-card-base-box-shadow;
    margin-bottom: 2.3rem;
  }

  .daily-meals-header {
    align-items: center;
    display: flex;
    justify-content: space-between;

    h2 {
      margin-bottom: 0;
    }

    .icon-arrow {
      font-size: 1.7rem;

      &:hover {
        cursor: pointer;
      }
    }
  }
  &.noMeals {
    min-height: 10rem;
    padding: 1.4rem 1.4rem;
    .row {
      height: 100%;
    }
    .no-results {
      font-size: 17px;
      // width: 70%;
      font-style: normal;
      font-weight: normal;
      line-height: 17px;
      margin-top: 1rem;
    }
    .daily-meals-header {
      h2 {
        font-size: 16px;
        font-style: normal;
        font-weight: 600;
        line-height: 19px;
      }
      span {
        color: var(--color);
        font-size: 16px;
        font-style: normal;
        font-weight: 600;
        line-height: 16px;
      }
    }
  }
}
</style>
